import { useAuth } from '@frontend/auth';
import { AuthErrorState, AuthStatusMessage } from '@frontend/ui';
import { Navigate } from 'react-router';

/**
 * Auth0 redirects here after universal login (`AUTH_CALLBACK_PATH`). The
 * provider's `onRedirectCallback` (wired in main.tsx) navigates to the
 * carried `returnTo`; this page covers the exchange window and falls back
 * to home if that callback never fires.
 */
export function CallbackPage() {
  const { status, error, login } = useAuth();

  if (error) {
    // This route's parent (RootLayout) has no nav chrome, so a failed
    // exchange needs its own way out. `/callback` is itself a spent route —
    // there's no trusted returnTo to reconstruct here — so retry with a
    // bare login(), same as login.tsx's untrusted-returnTo case.
    return (
      <AuthErrorState
        onRetry={() => {
          void login();
        }}
      />
    );
  }

  if (status === 'authed') {
    return <Navigate to="/" replace />;
  }

  return <AuthStatusMessage>Completing sign in…</AuthStatusMessage>;
}
